import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  InitialAvatarIcon,
  BaseText,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

interface IHelperData {
  icon: string;
  text: string;
  value: string;
  buttonLabel: string;
}

interface EmitEvents {
  (event: 'click'): void;
}
interface Props {
  type: string;
  searchValue: string;
  filtersCount: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyHelper',
  props: {
    type: null,
    searchValue: null,
    filtersCount: null
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props as {
  type: string;
  searchValue: string;
  filtersCount: number;
}





const helperData = computed(() => {
  const data: { [key: string]: IHelperData } = {
    search: {
      icon: 'EE0150',
      text: 'Não encontramos resultados para a busca',
      value: `"${props.searchValue}"`,
      buttonLabel: 'Limpar busca'
    },
    filter: {
      icon: 'EE0050',
      text: `Não encontramos resultados para ${
        props.filtersCount > 1 ? 'os' : ''
      }`,
      value: `"${props.filtersCount} ${
        props.filtersCount > 1 ? 'filtros aplicados' : 'filtro aplicado'
      }"`,
      buttonLabel: 'Limpar filtros'
    }
  };

  return data[props.type];
});

return { __sfc: true,props, helperData, NebraskaColors, InitialAvatarIcon, BaseText, ButtonSecondary }
}

})